export type AnnotationType = 'classification' | 'object_detection' | string | undefined

export interface MetricItem {
  label: string
  value: string
}

export type ModelMetrics = Record<string, unknown>

function getNumber(metrics: ModelMetrics | undefined, key: string): number | undefined {
  const value = metrics?.[key]
  return typeof value === 'number' ? value : undefined
}

export function formatPercent(value?: number, digits = 1): string {
  return typeof value === 'number' ? `${(value * 100).toFixed(digits)}%` : 'N/A'
}

export function buildKeyMetrics(
  annotationType: AnnotationType,
  metrics?: ModelMetrics
): MetricItem[] {
  if (!metrics) return []

  const isClassification = annotationType === 'classification'
  if (isClassification) {
    const valAcc = getNumber(metrics, 'validation:accuracy')
    const trainAcc = getNumber(metrics, 'train:accuracy')
    const precision =
      getNumber(metrics, 'validation:precision') ?? getNumber(metrics, 'train:precision')
    const recall = getNumber(metrics, 'validation:recall') ?? getNumber(metrics, 'train:recall')

    return [
      { label: 'Val Acc', value: formatPercent(valAcc) },
      { label: 'Train Acc', value: formatPercent(trainAcc) },
      { label: 'Precision', value: formatPercent(precision) },
      { label: 'Recall', value: formatPercent(recall) },
    ]
  }

  const mAP = getNumber(metrics, 'validation:mAP50')
  const precision = getNumber(metrics, 'validation:precision')
  const recall = getNumber(metrics, 'validation:recall')

  let f1Value = 'N/A'
  if (typeof precision === 'number' && typeof recall === 'number' && precision + recall > 0) {
    const f1 = (2 * (precision * recall)) / (precision + recall)
    f1Value = formatPercent(f1)
  } else if (precision === 0 || recall === 0) {
    f1Value = '0.0%'
  }

  return [
    { label: 'mAP@50', value: formatPercent(mAP) },
    { label: 'F1 Score', value: f1Value },
    { label: 'Precision', value: formatPercent(precision) },
    { label: 'Recall', value: formatPercent(recall) },
  ]
}
